import $ from 'jquery';
import ModalCarousel from './modalCarousel';

class Modal {
  constructor(element){
    this.$el = $(element);
    this.$modal = $('#weq-modal');
    this.$close = $('#weq-modal-close, .weq-modal-close');
    this.$el.on('click', (e) => {this.openModal(e)});
    this.$close.on('click', (e) => {this.closeModal()});
  }

  openModal(){
    if(this.$el.hasClass('weq-modal-carousel-start')){
      new ModalCarousel(this.$el);
    }
    this.$modal.addClass('open');
  }

  closeModal(){
    this.$modal.removeClass('open');
  }
}

if($('.weq-modal-start').length) {
  $('.weq-modal-start').each(function(index,element) {
    new Modal(element, index);
  });
}

if ($('.product-template-default')[0]) {
  let modal = new Modal();
}
